<template>
  <div class="osclaims" ref="container" style="height: 100%;">
    <!-- Left Panel -->
    <div
      v-show="!isMobile || (isMobile && showLeftPanel)"
      class="left-panel"
      :class="{ 'full-width': isMobile }"
      :style="{ flex: leftFlex }"
    >
      <LeftPanel @changePanel="togglePanel" />
    </div>

    <!-- Divider for resizing Left Panel -->
    <div v-show="!isMobile" class="divider" @mousedown="startDraggingLeft"></div>

    <!-- Center Panel -->
    <div
      v-show="!isMobile || (isMobile && !showLeftPanel)"
      class="center-panel"
      :class="{ 'full-width': isMobile }"
      :style="{ flex: centerFlex }"
    >
      <CenterPanel v-touch="{ right: goLeftPanel }" />
    </div>
  </div>
</template>

<script>
import LeftPanel from "@/components/osClaims/LeftPanel";
import CenterPanel from "@/components/osClaims/CenterPanel";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { setCustomBackHandler, useDefaultBackHandler } from "@/backButtonManager";
import router from "@/router";
import EventBus from "@/eventBus";

export default {
  name: "OSClaims",
  data() {
    return {
      isDraggingLeft: false,
      leftFlex: 2.2,
      centerFlex: 9,
      startX: 0,
      showLeftPanel: true,
      leftPanelStep: 'conversations',
    };
  },
  components: {
    LeftPanel,
    CenterPanel,
  },
  computed: {
    ...mapGetters("osclaims", ["loading"]),
    ...mapGetters("window", ["isMobile"]),
  },
  methods: {
    ...mapMutations("window", ["showBottomNav"]),
    ...mapMutations("osclaims", ["changeLoading"]),
    ...mapActions("osclaims", ["retrieveClaims"]),
    togglePanel() {
      if (this.isMobile) {
        this.showLeftPanel = !this.showLeftPanel;
      }
    },
    goLeftPanel() {
      if (!this.showLeftPanel) {
        this.showLeftPanel = true;
      }
    },
    startDraggingLeft(event) {
      this.isDraggingLeft = true;
      this.startX = event.clientX;
      document.addEventListener("mousemove", this.onDragLeft);
      document.addEventListener("mouseup", this.stopDragging);
    },
    onDragLeft(event) {
      if (!this.isDraggingLeft) return;
      const deltaX = event.clientX - this.startX;
      const totalFlex = this.leftFlex + this.centerFlex;

      const containerWidth = this.$refs.container.offsetWidth;
      const deltaFlex = (deltaX / containerWidth) * totalFlex;

      this.leftFlex = Math.max(1, Math.min(totalFlex - 2, this.leftFlex + deltaFlex));
      this.centerFlex = totalFlex - this.leftFlex;

      this.startX = event.clientX;
    },
    stopDragging() {
      this.isDraggingLeft = false;
      document.removeEventListener("mousemove", this.onDragLeft);
      document.removeEventListener("mouseup", this.stopDragging);
    },
  },
  created() {
    if (this.loading) {
      this.retrieveClaims("osclaims")
        .catch(console.error)
        .finally(() => this.changeLoading(false));
    }
  },
  mounted() {
    if (Capacitor.getPlatform() === "android") {
      setCustomBackHandler(() => {
        if (!this.showLeftPanel) {
          this.goLeftPanel();
        } else if (this.leftPanelStep === 'carrier-claims') {
          EventBus.$emit('leftPanelBack', 'carrier-list');
        } else if (this.leftPanelStep === 'carrier-list') {
          EventBus.$emit('leftPanelBack', 'conversations');
        } else {
          useDefaultBackHandler(router);
        }
      });
    }
    EventBus.$on("back-to-convoLeft", () => {
      this.showLeftPanel = true;
    });
    EventBus.$on("leftPanelStepChanged", (step) => {
      this.leftPanelStep = step;
    });
  },
  beforeUnmount() {
    EventBus.$off("back-to-convoLeft");
    EventBus.$off("leftPanelStepChanged");
  },
};
</script>

<style scoped>
.osclaims {
  display: flex;
  flex-direction: row;
  height: 100%;
}

.osclaims > * {
  margin: 0 1px;
}

.left-panel {
  flex: 10;
}

.center-panel {
  flex: 12;
}

.divider {
  width: 2px;
  background-color: #000;
  cursor: ew-resize;
}

.divider:hover {
  background-color: blue;
  width: 5px;
}

.full-width {
  width: 100%;
  flex: 1;
}
</style>